import ApiService from '../_helper/api.service';
import ManagementApiResources from '../../constants/api/resources/management';

const BookingService = {
  getBookingsList(data: any) {
    return ApiService.get(ManagementApiResources.bookings, data);
  },
  cancelBooking(data: any) {
    return ApiService.post(ManagementApiResources.cancelBooking, data);
  },
  getChangeBooking(data: any) {
    return ApiService.get(ManagementApiResources.changeBooking, { params: data });
  },
  setChangeBooking(data: any) {
    return ApiService.post(ManagementApiResources.changeBooking, data);
  },
  getCancellationInfo(data: any) {
    return ApiService.get(ManagementApiResources.cancelBooking, data);
  },
};

export default BookingService;
